// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/home/Index.vue'),
      children: [
        {
          path: '',
          name: 'Home',
          component: () => import('@/views/home/Index.vue'),
        },
        {
          path: 'cfp',
          name: 'CallforPapers',
          component: () => import('@/views/cfp/Index.vue'),
        },
        {
          path: 'key-dates',
          name: 'KeyDates',
          component: () => import('@/views/key-dates/Index.vue'),
        },
        {
          path: 'committee',
          name: 'Committees',
          component: () => import('@/views/committee/Index.vue'),
        },
        {
          path: 'venue',
          name: 'Venue',
          component: () => import('@/views/venue/Index.vue'),
        },
        {
          path: 'cusco-tour',
          name: 'CuscoTour',
          component: () => import('@/views/cusco-tour/Index.vue'),
        },
        {
          path: 'sponsors',
          name: 'Sponsors',
          component: () => import('@/views/sponsors/Index.vue'),
        },
      ],
    },

  ],
})

export default router
